export default "/images/95509df349127a2b55f5db4109fcb5e8.avif";